import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const TableSkeleton = ({ columns = [], rowCount = 10, height = 20 }) => {
  return (
    <div className={`table-container`}>
      <table className={`table`}>
        <thead className={`thead`}>
          <tr>
            {columns.map((col, index) => (
              <th key={index}  className={`colIndex === 0 && theadColumnOne`}>{col}</th>
            ))}
          </tr>
        </thead>
        <tbody className={`tbody`}>
          {Array.from({ length: rowCount }).map((_, rowIndex) => (
            <tr key={rowIndex}>
              {columns.map((_, colIndex) => (
                <td key={colIndex} className={`colIndex === 0 && tdataColumnOne`}>
                  <Skeleton height={height} />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TableSkeleton;